import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

type Params = {
  token: string;
  password: string;
};

type ResetPassword = ClientInferResponseBody<typeof contract.auth.resetPassword, 201>;

export const resetPassword = async ({ token, password }: Params): Promise<ResetPassword | null> => {
  const response = await api.auth.resetPassword.mutation({
    body: {
      password,
    },
    params: {
      token,
    },
  });

  if (response.status === 201) {
    return response.body;
  }

  return null;
};
